import { useEffect } from 'react';

/**
 * SEO Component - Updates document title and meta tags
 * Usage: <PageSEO title="Dashboard" description="Your financial command center" />
 */
export function PageSEO({ title, description }) {
  useEffect(() => {
    // Update document title
    const baseTitle = 'Zero Deficit Sync';
    document.title = title ? `${title} | ${baseTitle}` : baseTitle;
    
    // Update meta description
    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute('content', description);
      }
    }
    
    // Cleanup on unmount
    return () => {
      document.title = 'Zero Deficit Sync | Tax & Expense Tracker';
    };
  }, [title, description]);
  
  return null;
}

// Page-specific SEO configurations
export const pageSEO = {
  dashboard: {
    title: 'Dashboard',
    description: 'Your financial command center - track expenses, monitor deductions, and stay on top of your tax obligations.'
  },
  transactions: {
    title: 'Transactions',
    description: 'View and categorize your business transactions. Connect your bank with Plaid for automatic syncing.'
  },
  receipts: {
    title: 'Receipts',
    description: 'Scan and store receipts with AI-powered OCR. Auto-match receipts to transactions.'
  },
  mileage: {
    title: 'Mileage Tracker',
    description: 'Track business miles with GPS auto-tracking. Calculate IRS standard mileage deductions automatically.'
  },
  documents: {
    title: 'Documents',
    description: 'Organize your tax documents in folders. Store W-9s, invoices, and important business files.'
  },
  reports: {
    title: 'Reports',
    description: 'Generate IRS Schedule C reports, export data to CSV/PDF, and get tax-ready summaries.'
  },
  settings: {
    title: 'Settings',
    description: 'Manage your account settings, notification preferences, and data exports.'
  },
  pricing: {
    title: 'Pricing',
    description: 'Choose the right plan for your business. Free, Pro, and Business plans available.'
  },
  login: {
    title: 'Login',
    description: 'Sign in to Zero Deficit Sync - your smart tax and expense tracker.'
  },
  privacy: {
    title: 'Privacy Policy',
    description: 'Read our privacy policy to understand how we protect your financial data.'
  },
  terms: {
    title: 'Terms of Service',
    description: 'Review our terms of service for using Zero Deficit Sync.'
  }
};

export default PageSEO;
